export enum MasterPassTokenEnum {
  CHECK_MASTERPASSS = 1,
  REGISTER = 2,
  CARD_LIST = 3,
  REGISTER_PURCHASE = 4,
  RECURING_PAYMENT = 5,
  DELETE_CARD = 6,
  INITIATE_RECURRING_PAYMENT = 7,
  OTP = -1,
  RESEND_OTP = -2, //CUSTOM VALUE
  LINK = 22,
}
export enum MasterPassRefType {
  CARD_BALANCE = 2,
  ABONMAN = 7,
  DIGITAL_CARD_BALANCE = 6,
  DIGITAL_ABONMAN_BALANCE = 10,
  CARD_APPLICATION_BALANCE = 1,
}
/*
 * ⚠️ `MasterPassFormEnum` KALDIRILDI.
 *
 * Eski MFS SDK'sı isteklerini gizli bir HTML `<form>` üzerinden alıyordu; bu enum
 * o formların DOM id'lerini tutuyordu (`register-form`, `otp-form` vb.).
 * SDK v1.0.7 düz JSON kabul ettiği için form üretimi (`MasterPassHtlmHelper`) ve
 * bu enum gereksiz kaldı.
 */
/**
 * Masterpass SDK v1.0.7 işlem sonuç kodları.
 *
 * Eski MFS SDK'sıyla kodlar aynı ailedendir; değişen, kodun cevabın NERESİNDEN
 * okunacağıdır (`result.responseCode` ya da kök `responseCode`) — okuma için
 * her zaman `getMasterpassResponseCode()` kullan.
 */
export enum MasterpassResponseCodeEnum {
  /** İşlem başarılı. SDK bazı akışlarda boş string de dönebiliyor. */
  SUCCESS = '0000',
  /**
   * İşlem başarılı — İKİ HANELİ biçim.
   *
   * ⚠️ Masterpass bazı uçlarda `0000` yerine klasik ISO-8583 onay kodu `00`
   * döndürüyor. Sahada görülen örnek: `recurringOrderDelete` →
   * `HTTP 200`, `code=00`, `message="OK"`, `exception=null`.
   *
   * Bu kod başarı sayılmadığı için silme GERÇEKTEN yapılıyor ama istemci hata
   * gösteriyor, Belbim'e (`MB.OnApproveCardRecurringPayment`) haber verilmiyor
   * ve kayıt listede kalıyordu. Sonraki güncelleme/silme denemeleri de
   * `RECURRING_PAYMENT_ORDER_NOT_FOUND` alıyordu — çünkü emir çoktan silinmişti.
   */
  SUCCESS_SHORT = '00',
  /** RTA doğrulama adımı — kullanıcıdan hesabına düşen tutar isteniyor. */
  RTA_REQUIRED = '5000',
  /** SMS OTP adımı. */
  OTP_REQUIRED = '5001',
  /** SMS OTP adımı (alternatif kod). */
  OTP_REQUIRED_ALT = '5008',
  /** 3D Secure iframe akışı — adres `result.urlIFrame` alanındadır. */
  THREE_D_IFRAME = '5009',
  /** 3D Secure yönlendirme akışı — adres `url3d` alanındadır. */
  THREE_D_REDIRECT = '5010',
  /** Ek hesap (overdraft) sorgusu — SDK bunu kendi içinde `overdraftQuery`'ye yönlendirir. */
  OVERDRAFT = '5012',
  /** CVV doğrulama adımı. */
  CVV_REQUIRED = '5013',
  /** Kayıtlı talimat zaten mevcut — silip yeniden oluşturma akışını tetikler. */
  RECURRING_ALREADY_EXISTS = '4152',
  /**
   * Üye işyeri özelinde hesap/kart bulunamadı.
   *
   * ⚠️ Bu bir HATA DEĞİL, geçerli bir "kart yok" durumudur. Son kayıtlı kart
   * silindiğinde `accountAccess` bu kodla `404` döner. Gerçek servis
   * hatalarından ayrılmalı: aksi halde geçici bir arıza da kullanıcıya
   * "hiç kartınız yok" diye gösterilir.
   */
  ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND',
  /**
   * Masterpass hesabı var ama bu üye işyerine bağlanmamış.
   *
   * ⚠️ Bu da bir HATA DEĞİL: kullanıcının Masterpass'te kayıtlı kartları vardır,
   * yalnızca bu işyeriyle paylaşmaya henüz izin vermemiştir. Servis bu durumu
   * `accountAccess` çağrısına `404` + bu kodla bildiriyor (gövde:
   * `exception.message` = "Hesap iş yerine bağlı değil."). SDK hata
   * cevaplarında `exception.code`'u `responseCode`'a taşıdığı için
   * `getMasterpassResponseCode()` ile okunabilir.
   *
   * Genel hata dalına düşerse kullanıcıya "hiç kartınız yok" gösterilir ve
   * kartlarını getirecek izin (linkToMerchant) ekranı HİÇ açılmaz.
   */
  ACCOUNT_NOT_LINKED_TO_MERCHANT = 'ACCOUNT_NOT_LINKED_TO_MERCHANT',
}

export enum MasterPassAccountStatusEnum {
  NO_ACCOUNT = '0000000',
  YES_ACCOUNT_NO_CARD = '0100000',
  BLOCKED_ACCOUNT = '0100100',
  NO_LINKED = '0110001100000000',
}
export enum CardTransactionListTypeEnum {
  ALL,
  PAYMENT,
  LOAD,
}

export enum CardApplicationResponseTypeEnum {
  CANT_TAKE,
  CAN_TAKE,
  ALREADY_HAVE,
  FOREIGN,
}

export enum ApprovalStatusEnum {
  REJECT = 'R',
  PENDING = 'P',
  WAS_CREATED = 'S',
  WAITING_CREATE = 'W',
  CHECK = 'C',
  WAITING_APPLICATION = 'X',
}

export enum ApprovalRejectEnum {
  REJECT,
  INFORMATION_ERROR,
  PHOTO_ERROR,
  REPETETIVE_ERROR,
  EMPTY,
  SCAN_ERROR,
  OTHER_ERROR,
}

export enum PermissionStatus {
  GRANTED = 'granted',
  PROMPT = 'prompt',
  DENIED = 'denied',
}

export enum VIEW_TYPE {
  MAP,
  LIST,
}
